import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bd81992"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-h5 font-weight-bold mb-1" }, "Política de privacidad", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "1. Quién es responsable de tus datos", -1))
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "2. Qué datos tratamos", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Al registrarte:"),
    /*#__PURE__*/_createTextVNode(" nombre y apellidos, correo electrónico, contraseña, nick, ciudad, comunidad de juego, fecha de nacimiento y, si quieres, teléfono, nick de La Guerra del Anillo y foto de perfil. La contraseña se guarda cifrada con BCrypt: nadie puede leerla, tampoco nosotros. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Al usar la web:"),
    /*#__PURE__*/_createTextVNode(" tus inscripciones a eventos (fecha, si has pagado, el ejército elegido y si compartes tu correo con el organizador), las listas de ejército que subes, tus partidas y resultados, tu ELO y tu posición en las clasificaciones. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Al organizar un evento:"),
    /*#__PURE__*/_createTextVNode(" los datos que publicas del evento (nombre, lugar, fechas, precio, bases y cartel). ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Si nos escribes desde Contacto:"),
    /*#__PURE__*/_createTextVNode(" lo que pongas en el formulario, para responderte. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Datos técnicos:"),
    /*#__PURE__*/_createTextVNode(" como cualquier web, el servidor registra datos de las conexiones, como la dirección IP, por seguridad. De tu cuenta guardamos también cuántas veces has iniciado sesión y cuándo fue la última. ")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " No tratamos datos de pago: los eventos se pagan fuera de Amon Sûl y la web solo guarda si has pagado o no. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "3. Para qué y con qué base legal", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Crear y gestionar tu cuenta."),
    /*#__PURE__*/_createTextVNode(" Base: el servicio que pides al registrarte (art. 6.1.b RGPD). ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Inscribirte en eventos y que el organizador los gestione"),
    /*#__PURE__*/_createTextVNode(" (listas, pagos, rondas y resultados). Base: el servicio (art. 6.1.b). ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Mostrar a los demás usuarios tu nick, resultados, ELO y clasificaciones."),
    /*#__PURE__*/_createTextVNode(" Base: el servicio; es la finalidad de la web (art. 6.1.b). ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Que el organizador de un evento vea tu correo para contactarte."),
    /*#__PURE__*/_createTextVNode(" Base: tu consentimiento, que das al inscribirte y puedes retirar cuando quieras en Mi inscripción (art. 6.1.a). ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Avisos por correo de tus eventos"),
    /*#__PURE__*/_createTextVNode(" (inscripción, listas, rondas) "),
    /*#__PURE__*/_createElementVNode("strong", null, "y novedades de la web."),
    /*#__PURE__*/_createTextVNode(" Base: el servicio (art. 6.1.b) y el interés legítimo en informarte del servicio que usas (art. 6.1.f). Puedes desactivarlos en tu perfil; los correos de tu cuenta, como el de recuperar la contraseña, te llegan siempre. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Contar cuánto se usa la web"),
    /*#__PURE__*/_createTextVNode(" (cuántas veces inicias sesión y cuándo fue la última): solo para estadísticas de uso. Base: el interés legítimo en mantener y mejorar el servicio (art. 6.1.f). ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Proteger la web frente a abusos"),
    /*#__PURE__*/_createTextVNode(" (límite de intentos al iniciar sesión, registros del servidor). Base: el interés legítimo en la seguridad del servicio (art. 6.1.f). ")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " No tomamos decisiones automatizadas con efectos jurídicos sobre ti. El ELO es una puntuación deportiva calculada a partir de tus resultados. ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "4. Quién puede ver tus datos", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Cualquier usuario registrado:"),
    /*#__PURE__*/_createTextVNode(" tu nick, tu foto de perfil, tu ciudad, tu comunidad de juego, tus resultados, partidas, ELO e inscripciones a eventos y, cuando el organizador las hace visibles, las listas de ejército que entregas en un evento. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "El organizador de un evento al que te apuntas:"),
    /*#__PURE__*/_createTextVNode(" además, tu inscripción, si has pagado y tus listas. Tu correo, solo si lo compartes. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Nadie más"),
    /*#__PURE__*/_createTextVNode(" ve tu nombre, apellidos, correo, teléfono ni fecha de nacimiento. El responsable puede acceder a todos los datos para administrar la web y resolver incidencias. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Proveedores que nos prestan el servicio"),
    /*#__PURE__*/_createTextVNode(" (encargados del tratamiento), solo para eso: "),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, " Servidor de la aplicación y base de datos: SmarterASP.NET (site4now), en Países Bajos (UE). "),
      /*#__PURE__*/_createElementVNode("li", null, "Alojamiento de la web: Netlify, Inc. (EE. UU.)."),
      /*#__PURE__*/_createElementVNode("li", null, "Imágenes de listas y carteles: Cloudinary (EE. UU.)."),
      /*#__PURE__*/_createElementVNode("li", null, "Envío de correos: Google (Gmail).")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Servicios a los que se conecta tu navegador:"),
    /*#__PURE__*/_createTextVNode(" los mapas usan OpenStreetMap (direcciones y mapas de los eventos) y datos públicos alojados en GitHub (el mapa por provincias). Tu navegador se conecta directamente a ellos y les envía tu dirección IP. Si pulsas la dirección de un evento, se abre Google Maps. ")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No vendemos ni cedemos tus datos a nadie.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "5. Transferencias fuera del Espacio Económico Europeo", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Netlify y Cloudinary están en EE. UU. Las dos están adheridas al Marco de Privacidad de Datos UE-EE. UU. y sus contratos incluyen además las cláusulas contractuales tipo de la Comisión Europea. Google puede tratar datos fuera del EEE con esas mismas garantías. OpenStreetMap está en Reino Unido, que cuenta con una decisión de adecuación de la Comisión Europea. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "6. Cuánto tiempo guardamos tus datos", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Mientras tengas la cuenta."),
  /*#__PURE__*/_createElementVNode("li", null, " Si la borras, desde tu perfil o escribiéndonos, eliminamos tus datos personales. Tus resultados y partidas siguen en las clasificaciones y en los eventos, sin nada que te identifique: aparecerás como «Desconocido» seguido de un número. Si estás inscrito en un evento que no ha terminado, o lo organizas, podrás borrarla cuando termine. "),
  /*#__PURE__*/_createElementVNode("li", null, " El permiso para que el organizador vea tu correo dura lo que tu inscripción, o hasta que lo retires. "),
  /*#__PURE__*/_createElementVNode("li", null, "Los enlaces para recuperar la contraseña caducan en una hora.")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "7. Menores", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Para registrarte necesitas tener al menos 14 años (art. 7 LOPDGDD). El registro lo comprueba con tu fecha de nacimiento. ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "8. Tus derechos", -1))
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Si crees que no hemos tratado bien tus datos, puedes reclamar ante la Agencia Española de Protección de Datos ("),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.aepd.es",
    target: "_blank",
    rel: "noopener"
  }, "www.aepd.es"),
  /*#__PURE__*/_createTextVNode("). ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "9. Lo que se guarda en tu navegador", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Solo lo necesario para mantener tu sesión: el token de acceso, tu correo y tu identificador de usuario. Se borran al cerrar sesión. No usamos cookies de análisis ni de publicidad. ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "10. Cambios en esta política", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Si la cambiamos, lo avisaremos en la web y, si el cambio es importante, por correo. ", -1))

const ULTIMA_ACTUALIZACION = "2 de noviembre de 2026";
const RESPONSABLE = "José Antonio Sánchez Molina";
const CONTACTO = "jose.a.sanchez.molina@gmail.com";

export default /*#__PURE__*/_defineComponent({
  __name: 'PoliticaPrivacidadView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "politica" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", { class: "text-caption text-medium-emphasis mb-6" }, " Última actualización: " + _toDisplayString(ULTIMA_ACTUALIZACION)),
      _hoisted_2,
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, " Responsable: " + _toDisplayString(RESPONSABLE) + ", que gestiona Amon Sûl a título personal. "),
        _createElementVNode("li", null, [
          _createTextVNode(" Contacto: "),
          _createElementVNode("a", {
            href: `mailto:${CONTACTO}`
          }, _toDisplayString(CONTACTO), 8, _hoisted_3)
        ])
      ]),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _hoisted_19,
      _createElementVNode("p", null, [
        _createTextVNode(" Puedes pedir acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad de tus datos, y retirar cuando quieras un consentimiento que hayas dado, escribiendo a "),
        _createElementVNode("a", {
          href: `mailto:${CONTACTO}`
        }, _toDisplayString(CONTACTO), 8, _hoisted_20),
        _createTextVNode(". Muchos datos puedes cambiarlos tú en tu perfil, y desde ahí también puedes borrar tu cuenta. ")
      ]),
      _hoisted_21,
      _hoisted_22,
      _hoisted_23,
      _hoisted_24,
      _hoisted_25
    ]),
    _: 1
  }))
}
}

})